module.exports = __webpack_public_path__ + "static/media/cover.8ed69824.png";